export default "__VITE_ASSET__BaMKsw_x__"